import jwt_decode from 'jwt-decode';
import {ENTITY_MAP, ROLE_MAP} from 'app-ui-componentlibrary/dist/common/constants';
import REST from 'go/requests/rest';
import _ from 'lodash';

export default class PermissionsUtility {
  jwt = '';
  permissions = [];
  programs = [];
  organizations = [];
  suborganizations = [];
  subappOrgs = [];
  subappOrgIds = []; // Organizations by id that are allowed to create subapplications.
  roles = new Map();
  femaSystemRoles = [];
  entityTypeIdList = [];
  obj = {
    org: [],
    orgPrg: new Map(),
    orgSuborgPrg: new Map(),
    orgParentOrgForSuborg: new Map(), //GMMGO-12136
    orgParentOrgListForSuborg: new Map(),
  };

  constructor(token) {
    this.permissions = JSON.parse(JSON.stringify(token.permissions));

    this.permissions.sort().forEach((permission) => {
      let [entityTypeId, entityId, roleId] = permission.split(':');

      this.entityTypeIdList.push(entityTypeId);

      switch (entityTypeId) {
        case ENTITY_MAP.ORGANIZATION.code: {
          this.obj.org.push(entityId);
          this.organizations.push(entityId);
          this.roles.set(entityId, roleId);
          if (this.obj.orgParentOrgListForSuborg.has(entityId)) {
            let parentOrgIds = this.obj.orgParentOrgListForSuborg.get(entityId);
            if (!_.includes(parentOrgIds, entityId)) {
              parentOrgIds.push(entityId);
            }
            this.obj.orgParentOrgListForSuborg.set(entityId, parentOrgIds);
          } else {
            this.obj.orgParentOrgListForSuborg.set(entityId, [entityId]);
          }

          break;
        }
        case ENTITY_MAP.PROGRAM_ORGANIZATION.code: {
          let [orgId, prgId] = entityId.split('_');
          this.roles.set(orgId, roleId);
          let orgProgram = this.obj.orgPrg.get(prgId);
          this.programs.push(prgId);
          this.organizations.push(orgId);
          if (orgProgram === undefined) {
            this.obj.orgPrg.set(prgId, [orgId]);
          } else {
            orgProgram.push(orgId);
            this.obj.orgPrg.set(prgId, orgProgram);
          }

          break;
        }
        case ENTITY_MAP.PROGRAM_ORGANIZATION_SUBORGANIZATION.code: {
          let [orgId, prgId, subOrgId] = entityId.split('_');
          this.roles.set(subOrgId, roleId);
          this.programs.push(prgId);
          this.organizations.push(orgId);
          this.suborganizations.push(subOrgId);
          let programIds = [];

          this.suborganizations.forEach(() => {
            if (this.obj.orgParentOrgListForSuborg.has(subOrgId)) {
              let parentOrgIds = this.obj.orgParentOrgListForSuborg.get(subOrgId);
              if (!_.includes(parentOrgIds, orgId)) {
                parentOrgIds.push(orgId);
              }
              this.obj.orgParentOrgListForSuborg.set(subOrgId, parentOrgIds);
            } else {
              this.obj.orgParentOrgListForSuborg.set(subOrgId, [orgId]);
            }
          });

          this.obj.orgSuborgPrg.forEach((value, key, map) => {
            programIds.push(key);
          });
          if (_.includes(programIds, prgId)) {
            let orgSuborg = this.obj.orgSuborgPrg.get(prgId).get(orgId);

            if (orgSuborg !== undefined) {
              orgSuborg.push(subOrgId);
            } else {
              this.obj.orgSuborgPrg.get(prgId).set(orgId, [subOrgId]);
            }
          } else {
            let orgSuborg = new Map();
            orgSuborg.set(orgId, [subOrgId]);
            this.suborganizations.forEach(() => {
              //GMMGO-12136
              this.obj.orgParentOrgForSuborg.set(subOrgId, orgId);
            });
            this.obj.orgSuborgPrg.set(prgId, orgSuborg);
          }

          break;
        }
        case ENTITY_MAP.PROGRAM_EXTERNAL.code: {
          this.programs.push(entityId);
          break;
        }
        case ENTITY_MAP.FEMA_SYSTEM.code: {
          this.femaSystemRoles.push(roleId);
        }
        default: {
          break;
        }
      }
    });
    this.programs = _.sortBy(_.uniq(this.programs), function (obj) {
      return parseInt(obj, 10);
    });
    this.organizations = _.sortBy(_.uniq(this.organizations), function (obj) {
      return parseInt(obj, 10);
    });
    this.suborganizations = _.sortBy(_.uniq(this.suborganizations), function (obj) {
      return parseInt(obj, 10);
    });
  }

  getOrganizationsForProgram(program) {
    let orgs = [];
    if (this.obj.orgPrg.get(program) !== undefined) {
      orgs.push(...this.obj.orgPrg.get(program));
    }
    if (this.obj.orgSuborgPrg.get(program) !== undefined) {
      for (var [key] of this.obj.orgSuborgPrg.get(program)) {
        orgs.push(key);
      }
    }
    return _.uniq(orgs);
  }
  getSuborganizationsForProgram(program) {
    return this.obj.orgSuborgPrg.get(program);
  }
  getOrganizations() {
    return this.organizations;
  }
  getSuborganizations() {
    return this.suborganizations;
  }
  getPrograms() {
    return this.programs;
  }
  getRoles() {
    return this.roles;
  }
  getSubapplicationOrganizations() {
    return this.subappOrgs;
  }
  // Return the unique set of organizations by id that are allowed to create subapplications.
  getSubapplicationOrganizationIds() {
    return this.subappOrgIds;
  }

  //GMMGO-12136 This function is not working as this is getting only 1 parent even when there are multiple parents
  //Remove this function once all the references to this function are replaced with the new function getParentOrgIdListForSubOrg
  getParentOrgIdForSubOrg = (subOrgId) => {
    return this.obj.orgParentOrgForSuborg.get(subOrgId);
  };

  // This will get the list of parents orgs for a suborg
  getParentOrgIdListForSubOrg = (subOrgId) => {
    return this.obj.orgParentOrgListForSuborg.get(_.toString(subOrgId));
  };

  //GMMGO-12136
  getOrgListForEntityOneAndFive = (token) => {
    let permissions = [];
    let organizations = [];

    permissions = token.permissions;
    permissions.forEach((permission) => {
      let [entityTypeId, entityId, roleId] = permission.split(':');
      switch (entityTypeId) {
        case ENTITY_MAP.ORGANIZATION.code: {
          organizations.push(entityId);
          break;
        }
        case ENTITY_MAP.PROGRAM_ORGANIZATION.code: {
          let [orgId, prgId] = entityId.split('_');
          organizations.push(orgId);
          break;
        }
        default: {
          break;
        }
      }
    });
    return organizations;
  };

  getProgramForOrganization = (selectedOrgId) => {
    let programs = [];
    this.obj.orgPrg.forEach((value, key, map) => {
      if (_.includes(value, selectedOrgId)) {
        programs.push(key);
      }
    });
    this.obj.orgSuborgPrg.forEach((value, key, map) => {
      value.forEach((mapValue, mapKey, map) => {
        if (_.includes(mapValue, selectedOrgId)) {
          programs.push(key);
        }
      });
    });
    return _.uniq(programs);
  };

  //GMMGO-12136
  getOrgListForEntityTypeSix = (token) => {
    let permissions = [];
    let subOrganizations = [];
    permissions = token.permissions;
    permissions.forEach((permission) => {
      let [entityTypeId, entityId, roleId] = permission.split(':');
      switch (entityTypeId) {
        case ENTITY_MAP.PROGRAM_ORGANIZATION_SUBORGANIZATION.code: {
          let [orgId, prgId, subOrgId] = entityId.split('_');
          subOrganizations.push(_.toInteger(subOrgId));
          break;
        }
        default: {
          break;
        }
      }
    });
    return subOrganizations;
  };

  //GMMGO-12136
  isCurrentIdExistForEntityOneAndFive = (subOrgId, token) => {
    let organizationsForEntityOneAndFive = [];
    let currentIdExistForEntityOneAndFive = false;
    organizationsForEntityOneAndFive = this.getOrgListForEntityOneAndFive(token);
    if (organizationsForEntityOneAndFive.includes(subOrgId)) {
      currentIdExistForEntityOneAndFive = true;
    }
    return currentIdExistForEntityOneAndFive;
  };

  //GMMGO-12599
  isCurrentIdExistForEntitySix = (subOrgId, token) => {
    let subOrgIdInt = subOrgId;
    if (typeof subOrgId === 'string' && subOrgId.trim() != '') {
      const isStringNumber = Number.isFinite(+subOrgId); //unary + operator coirces value to its numeric form
      if (isStringNumber) {
        subOrgIdInt = _.toInteger(subOrgId);
      }
    }
    return _.includes(this.getOrgListForEntityTypeSix(token), subOrgIdInt);
  };

  getProgramIdAndCategoryIdByOrgId = (token, orgId) => {
    return REST.organizationRelationship
      .getAllUnrestrictedOrganizationProgramsByOrgId(token, orgId)
      .then(REST.handler.handleResponse)
      .then((res) => {
        let programCategoryIds = [];
        let eligibleProgramIds = [];
        let programIdandCategory = {
          eligibleProgramIds,
          programCategoryIds,
        };
        if (res) {
          const programs = res;
          const params = _.chain(programs).map('programId').join(',').value();
          return REST.program
            .getProgramDetails(token, params)
            .then(REST.handler.handleResponse)
            .then((res) => {
              if (res) {
                let programs = res;
                programs = _.orderBy(programs, ['programId'], ['asc']);
                _.map(programs, (prog) => {
                  if (prog.subapplicationFlag === true) {
                    eligibleProgramIds.push(prog.programId);
                    programCategoryIds.push(prog.programCategoryId);
                  }
                });
              }
              return programIdandCategory;
            });
        }
      });
  };

  getSubOrgProgramIdAndCategoryIdByOrgId(token, orgId, subOrgId) {
    return REST.organizationRelationship
      .getSubOrgProgramsByParentOrgIdAndSubOrgId(token, orgId, subOrgId)
      .then(REST.handler.handleResponse)
      .then((res) => {
        let programCategoryIds = [];
        let eligibleProgramIds = [];
        let programIdandCategory = {
          eligibleProgramIds,
          programCategoryIds,
        };
        if (res) {
          const programs = res.suborganizationPrograms;
          const params = _.chain(programs).map('programId').join(',').value();
          return REST.program
            .getProgramDetails(token, params)
            .then(REST.handler.handleResponse)
            .then((res) => {
              if (res) {
                let programs = res;
                programs = _.orderBy(programs, ['programId'], ['asc']);
                _.map(programs, (prog) => {
                  if (prog.subapplicationFlag === true) {
                    eligibleProgramIds.push(prog.programId);
                    programCategoryIds.push(prog.programCategoryId);
                  }
                });
              }
              return programIdandCategory;
            });
        }
      });
  }

  hasPermsForFundingOpportunity = (fundingOpportunityId) => {
    return !!_.chain(this.permissions)
      .map((permission) => {
        let [entityTypeId, entityId] = permission.split(':');
        return (
          entityTypeId === ENTITY_MAP.FUNDING_OPPORTUNITY.code &&
          entityId === `${fundingOpportunityId}`
        );
      })
      .filter((value) => value !== undefined && value === true)
      .uniq()
      .value()[0];
  };

  hasPermsForSubOrgOrEntity = (organizationId, entityIds) => {
    const entityTypes = _.uniq(this.entityTypeIdList);
    const userSubOrgs = _.includes(
      entityTypes,
      ENTITY_MAP.PROGRAM_ORGANIZATION_SUBORGANIZATION.code
    )
      ? this.getSuborganizations()
      : _.intersection(entityTypes, [
          ENTITY_MAP.PROGRAM_ORGANIZATION.code,
          ENTITY_MAP.ORGANIZATION.code,
        ])
      ? this.getOrganizations()
      : undefined;

    return (
      _.includes(userSubOrgs, organizationId.toString()) ||
      !_.isEmpty(_.intersection(entityTypes, entityIds))
    );
  };

  getSubAppOrgs = (token) => {
    return REST.organizationRelationship
      .getOrgPrograms(token)
      .then(REST.handler.handleResponse)
      .then((res) => {
        let subAppOrgs = [];
        if (res) {
          const programs = res;
          const ids = new Set(_.map(programs, 'programId'));
          const params = Array.from(ids).toString();
          return REST.program
            .getProgramDetails(token, params)
            .then(REST.handler.handleResponse)
            .then((res) => {
              if (res) {
                const programs = res;
                _.map(programs, (prog) => {
                  if (
                    prog.subapplicationFlag === true &&
                    !_.includes(this.subappOrgs, prog.organizationId)
                  ) {
                    this.subappOrgs.push(prog.organizationId);
                    subAppOrgs.push(prog.organizationId);
                  }
                });
              }
              return subAppOrgs;
            });
        }
      });
  };

  // Return the unique set of organizations by id that are allowed to create subapplications.
  getSubAppOrgIds = (token) => {
    // Get all the programs associated with each organizaiton.
    return REST.organizationRelationship
      .getAllOrganizationProgramsUnrestricted(token)
      .then(REST.handler.handleResponse)
      .then((res) => {
        let subAppOrgIds = [];
        if (res) {
          const programs = res;

          // Get a uniq set of program ids.
          const ids = new Set(_.map(programs, 'programId'));

          // Reverse map the program ids to the list of organizations associated with them.
          // This will give you a unique mapping between a program id and all the organizations
          // associated with it.
          const progToOrgMap = {};
          _.map(programs, (prog) => {
            if (!progToOrgMap[prog.programId.toString()]) {
              progToOrgMap[prog.programId.toString()] = [];
            }
            progToOrgMap[prog.programId.toString()].push(prog.organizationId);
          });

          const params = Array.from(ids).toString();
          // Get details for all the unique program ids.
          return REST.program
            .getProgramDetails(token, params)
            .then(REST.handler.handleResponse)
            .then((res) => {
              if (res) {
                const programDetails = res;
                let allOrgIds = []; // Holds the union of all organizations associated with programs that allow subapplications.
                _.map(programDetails, (prog) => {
                  // If a program allows subapplications, add the associated organizations to the union.
                  if (prog.subapplicationFlag === true) {
                    allOrgIds = _.concat(
                      allOrgIds,
                      progToOrgMap[prog.programId.toString()]
                    );
                  }
                });

                // Get all unique organizations that have programs that allow subapplications.
                this.subappOrgIds = _.uniq(allOrgIds);
              }

              subAppOrgIds = this.subappOrgIds;
              return subAppOrgIds;
            });
        }
      });
  };

  hasAnySystemRole = (systemRoles) => {
    return !_.isEmpty(_.intersection(systemRoles, this.femaSystemRoles));
  };
}
